/* template */
<template><div class="swiper-container"><template v-if="(banners && banners.length)"><template v-if="(banners && banners.length ===1)"><template v-for="(item, index) in (banners)"><mpx-image :src="(item.url)" @tap="bannerClickHandle(item)" mode="aspectFill" class="swiper-box-item-image"/></template></template><template v-else><mpx-swiper autoplay circular :current="(0)" :interval="(3000)" @change="handleIndexChange" class="swiper-box"><mpx-swiper-item v-for="(item, index) in (banners)" :key="item.index" class="swiper-box-item"><mpx-image :src="(item.url)" @tap="bannerClickHandle(item)" mode="aspectFill" class="swiper-box-item-image"/></mpx-swiper-item></mpx-swiper></template><div class="dots" v-if="(banners && banners.length > 1)"><div v-for="(item, index) in (banners)" :key="item.index" :class='("dot-item "+(currentKey === index ? "active" : ""))'></div></div></template></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m57e2b6a8"}'>
  .max-size
    width 100%
    height 100%
  .swiper-container
    position relative
    background #ff6400
    @extend .max-size
    .swiper-box
      @extend .max-size
      &-item
        @extend .max-size
        &-image
          @extend .max-size
    .dots
      width 100%
      display flex
      justify-content center
      position absolute
      bottom 83px
      pointer-events none
      .dot-item
        width 3px
        height 2px
        opacity 0.7
        background #fff
        border-radius 2px
        margin-right 2px
        transition all 200ms
      .active
        width 6px
        height 2px
        background #fff
        opacity 1
        border-radius 2px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m57e2b6a8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex57e2b6a8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex57e2b6a8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m57e2b6a8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index57e2b6a8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-swiper':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-swiper-item':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper-item.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
